const Price = (val) => {
  var formato = { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' }
  return val.toLocaleString('pt-BR', formato);
}

export default Price;